import { UserApiUserSignupRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useSignupMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserSignupRequest, config) =>
      appApiClient.userApi.userSignup(req, config),
  })
